import React, { useContext, useCallback } from 'react';
import { CustomersContext, ICustomersContext } from '../customersState/customersContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalSentSuccessfullyNew } from 'components/ModalWindows/ModalSentSuccessfullyNew';
import { ModalSentErrorNew } from 'components/ModalWindows/ModalSentErrorNew';
import { ModalToConfirmNew } from 'components/ModalWindows/ModalToConfirmNew';

export const ModalWindows: React.FC = () => {
	const { deleteSelectedItem, archiveSelectedItem, restoreSelectedItem, changeTypeOfModalWindow, typeOfModalWindow } =
		useContext<ICustomersContext>(CustomersContext);

	const handleChangeTypeOfModalWindow = useCallback(() => changeTypeOfModalWindow(null), [changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			{typeOfModalWindow === 'toConfirmDeleteItem' && (
				<ModalToConfirmNew
					onConsentEvent={deleteSelectedItem}
					onFailureEvent={handleChangeTypeOfModalWindow}
					description="deleteCustomer"
					additionalDescription="deleteCustomerDescription"
					typeOfInfoIcon="toDelete"
				/>
			)}
			{typeOfModalWindow === 'toConfirmArchiveItem' && (
				<ModalToConfirmNew
					onConsentEvent={archiveSelectedItem}
					onFailureEvent={handleChangeTypeOfModalWindow}
					description="archiveCustomer"
					additionalDescription="archiveCustomerDescription"
					typeOfInfoIcon="toArchive"
				/>
			)}
			{typeOfModalWindow === 'archiveSuccess' && (
				<ModalSentSuccessfullyNew
					onConsentEvent={handleChangeTypeOfModalWindow}
					description="archiveCustomerSuccessfully"
				/>
			)}
			{typeOfModalWindow === 'archiveError' && (
				<ModalSentErrorNew
					onConsentEvent={handleChangeTypeOfModalWindow}
					description="errorWhileArchivingCustomer"
				/>
			)}
			{typeOfModalWindow === 'toConfirmRestoreItem' && (
				<ModalToConfirmNew
					onConsentEvent={restoreSelectedItem}
					onFailureEvent={handleChangeTypeOfModalWindow}
					description="restoreCustomer"
					additionalDescription="restoreCustomerDescription"
					typeOfInfoIcon="toRestore"
				/>
			)}
			{typeOfModalWindow === 'restoreSuccess' && (
				<ModalSentSuccessfullyNew
					onConsentEvent={handleChangeTypeOfModalWindow}
					description="restoreCustomerSuccessfully"
				/>
			)}
			{typeOfModalWindow === 'restoreError' && (
				<ModalSentErrorNew
					onConsentEvent={handleChangeTypeOfModalWindow}
					description="errorWhileRestoringCustomer"
				/>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfullyNew
					onConsentEvent={handleChangeTypeOfModalWindow}
					description="deleteCustomerSuccessfully"
				/>
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentErrorNew
					onConsentEvent={handleChangeTypeOfModalWindow}
					description="errorWhileDeletingCustomer"
				/>
			)}
		</ModalWrapper>
	);
};
